/* ============================================================
   custom.js - eigen aanpassingen Margaret & Birdie
   Geladen via snippets/stylesheets.liquid.

   Doet twee dingen met de vaste 'Add to cart'-balk onderin:
   1. Breidt hem uit met de doorgestreepte oude prijs, het
      SAVE-percentage en een rij maatknoppen.
   2. Houdt hem tegen tot de bezoeker wat verder op de pagina zit.

   De maten komen uit de maatkiezer van het product zelf, dus elk
   product toont zijn eigen maten (kledingmaten, schoenmaten, wat dan
   ook). De knoppen in de balk zijn een spiegel: een klik wordt
   doorgegeven aan de echte knop hoger op de pagina, zodat alle logica
   van het thema (beschikbaarheid, prijs, afbeelding) van het thema
   blijft. Staat er geen maatkiezer op de pagina, dan blijft de rij weg.
   ============================================================ */
(function () {
  'use strict';

  var bar = document.querySelector('[data-sticky-bar]');
  if (!bar) return;

  var price = bar.querySelector('[data-sticky-price]');
  if (!price || !bar.querySelector('.product-sticky-bar__content')) return;

  /* ---------- opbouw ---------- */
  var left = price.parentElement;
  left.classList.add('sb-left');

  var compare = document.createElement('p');
  compare.className = 'sb-compare';
  compare.hidden = true;
  left.insertBefore(compare, price);

  var priceRow = document.createElement('div');
  priceRow.className = 'sb-price-row';
  left.insertBefore(priceRow, price);
  priceRow.appendChild(price);

  var save = document.createElement('span');
  save.className = 'sb-save';
  save.hidden = true;
  priceRow.appendChild(save);

  var sizes = document.createElement('div');
  sizes.className = 'sb-sizes';
  sizes.setAttribute('role', 'group');
  bar.appendChild(sizes);

  /* ---------- hulpjes ---------- */
  /* De laatste optiegroep met gewone tekstknoppen is de maatkiezer.
     Kleurstalen en afbeeldingsknoppen slaan we over. */
  function sizeGroup() {
    var groups = document.querySelectorAll('.product-info__option-group');
    var found = null;
    for (var i = 0; i < groups.length; i++) {
      if (groups[i].querySelector('.product-info__option-values--normal')) found = groups[i];
    }
    return found;
  }

  function textOf(selector) {
    var el = document.querySelector(selector);
    if (!el) return '';
    return (el.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function stateOf(button) {
    return {
      value: button.getAttribute('data-option-value') || '',
      active: button.classList.contains('is-active'),
      unavailable: button.classList.contains('is-unavailable'),
      disabled: button.disabled || button.getAttribute('aria-disabled') === 'true'
    };
  }

  /* ---------- bijwerken ----------
     We vergelijken eerst een korte samenvatting van de huidige stand.
     Is die niet veranderd, dan raken we het DOM niet aan. Dat scheelt
     onnodig herbouwen (de aftelklok tikt elke seconde). */
  var lastSignature = null;

  function render() {
    var oldPrice = textOf('.product-info__compare');
    var saving = textOf('.product-info__savings-badge');

    var group = sizeGroup();
    var states = [];

    if (group) {
      var originals = group.querySelectorAll('button[data-option-button]');
      for (var i = 0; i < originals.length; i++) states.push(stateOf(originals[i]));
    }

    var signature = JSON.stringify([oldPrice, saving, states]);
    if (signature === lastSignature) return;
    lastSignature = signature;

    compare.textContent = oldPrice;
    compare.hidden = !oldPrice;

    save.textContent = saving;
    save.hidden = !saving;

    if (!states.length) {
      sizes.hidden = true;
      sizes.textContent = '';
      return;
    }

    sizes.hidden = false;

    var header = group.querySelector('.product-info__option-header');
    if (header && header.firstElementChild) {
      sizes.setAttribute('aria-label', (header.firstElementChild.textContent || '').trim());
    }

    var fragment = document.createDocumentFragment();

    for (var j = 0; j < states.length; j++) {
      var state = states[j];
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'sb-size';
      button.textContent = state.value;
      button.setAttribute('data-sb-value', state.value);
      if (state.active) button.classList.add('is-active');
      if (state.unavailable) button.classList.add('is-unavailable');
      if (state.disabled) button.disabled = true;
      fragment.appendChild(button);
    }

    sizes.textContent = '';
    sizes.appendChild(fragment);
  }

  /* setTimeout in plaats van requestAnimationFrame: rAF ligt stil in een
     tabblad op de achtergrond, en dan zou de balk verouderd terugkomen. */
  function scheduleRender() {
    if (scheduleRender.queued) return;
    scheduleRender.queued = true;
    setTimeout(function () {
      scheduleRender.queued = false;
      render();
    }, 0);
  }

  /* ---------- klik doorgeven aan de echte maatkiezer ---------- */
  sizes.addEventListener('click', function (event) {
    var button = event.target.closest ? event.target.closest('.sb-size') : null;
    if (!button) return;

    var group = sizeGroup();
    if (!group) return;

    var value = button.getAttribute('data-sb-value') || '';
    var originals = group.querySelectorAll('button[data-option-button]');

    for (var i = 0; i < originals.length; i++) {
      if (originals[i].getAttribute('data-option-value') === value) {
        originals[i].click();
        break;
      }
    }
  });

  /* ============================================================
     De balk pas later laten verschijnen
     ============================================================
     Het thema toont de balk zodra de koopknop net uit beeld is. Dat
     voelt te vroeg, dus houden we hem nog even tegen met de class
     .sb-gated (zie custom.css): pas als de koopknop ruim een half
     scherm boven de bovenkant van het venster zit, laten we los.
     We verbergen alleen extra - het tonen blijft aan het thema, zodat
     bijvoorbeeld het wegvallen bij de footer gewoon blijft werken.

     Wil je hem later of eerder laten komen? Verander alleen dit getal:
     0.6 = ruim een half scherm extra scrollen, 1 = een heel scherm. */
  var REVEAL_AFTER_SCREENS = 0.6;

  bar.classList.add('sb-gated');

  function buyButtonsBlock() {
    return (
      document.querySelector('.product-info__buy-buttons') ||
      document.querySelector('.product-info__add')
    );
  }

  function updateGate() {
    var anchor = buyButtonsBlock();

    if (!anchor) {
      bar.classList.remove('sb-gated');
      return;
    }

    var limit = -(window.innerHeight * REVEAL_AFTER_SCREENS);
    bar.classList.toggle('sb-gated', anchor.getBoundingClientRect().bottom > limit);
  }

  /* Op mobiel scrolt het venster zelf, op grote schermen scrolt
     .page-wrapper (base.css zet html en body daar op overflow: hidden).
     Scroll-events van een element bubbelen niet en zijn ook in de
     capture-fase op document niet te vangen, dus luisteren we gewoon op
     allebei. */
  window.addEventListener('scroll', updateGate, { passive: true });
  window.addEventListener('resize', updateGate, { passive: true });

  var pageWrapper = document.querySelector('.page-wrapper');
  if (pageWrapper) pageWrapper.addEventListener('scroll', updateGate, { passive: true });

  updateGate();

  /* ---------- in sync blijven met de pagina ----------
     Mutaties binnen de balk zelf negeren we, anders houdt het
     bijwerken zichzelf aan de gang. */
  var observer = new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      var target = records[i].target;
      var node = target && target.nodeType === 1 ? target : target && target.parentElement;
      if (node && bar.contains(node)) continue;
      scheduleRender();
      return;
    }
  });

  observer.observe(document.body, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['class', 'aria-pressed', 'aria-disabled', 'disabled']
  });

  /* Een klik op de echte maatkiezer verwerkt het thema soms asynchroon,
     dus kijken we daar ook nog even later naar. */
  document.addEventListener(
    'click',
    function (event) {
      if (!event.target.closest) return;
      if (!event.target.closest('[data-option-button]')) return;
      setTimeout(render, 0);
      setTimeout(render, 300);
    },
    true
  );

  render();
})();
